import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "font-semibold text-xl md:text-2xl leading-[24px] md:leading-[32px] text-brown mb-4 w-full text-left" }
const _hoisted_2 = { class: "text-base leading-[20px] text-brown mb-1 w-full text-left" }
const _hoisted_3 = {
  key: 0,
  class: "md:font-bold"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "list-disc pl-7 text-left text-brown text-base leading-[20px] mb-4" }
const _hoisted_6 = { class: "md:font-bold" }
const _hoisted_7 = { class: "text-base leading-[20px] text-brown mb-1 w-full text-left md:font-bold" }
const _hoisted_8 = { class: "text-base leading-[20px] text-brown mb-1 w-full text-left" }

import { useI18n } from "vue-i18n";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DayRuneInstruction',
  setup(__props) {

const { tm } = useI18n();

const faq = computed(() => tm("calculators.day-rune.faq") as unknown);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(faq.value.first_title), 1),
    _createElementVNode("p", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.value.first_paragraph, (p, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          (p.type === 'bold')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(p.text), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(p.text), 1))
        ], 64))
      }), 128))
    ]),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.value.list, (item, i) => {
        return (_openBlock(), _createElementBlock("li", { key: i }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(item.bold), 1),
          _createTextVNode(" " + _toDisplayString(item.text), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("h6", _hoisted_7, _toDisplayString(faq.value.second_title), 1),
    _createElementVNode("p", _hoisted_8, _toDisplayString(faq.value.second_paragraph), 1)
  ], 64))
}
}

})